export const environment = {
  production: false,
  urlApiKras: 'https://kras-api.dev.sla-hyvs.devtest.gf.aws.scania.com/api/'
};
